import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import { Link } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { salesDeveloperPrefix } from 'configs/routePrefix'
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from 'store/adminFilter/actions'
import EditRateModal from '../EditRateModal'
import SuccessModal from 'components/SucessModal'
import { appendData } from 'store/Mode/actions'
import '../style.scss'
import ModalForm from '../UploadModalInteractive'
import InterActiveModeService from 'services/SalesDeveloper/InterActiveModeService'

const CardItem = ({ index, itemData, Service,history, updateHandler, status, setShouldGetData }) => {
    const service = new Service
    const interActiveModeService = new InterActiveModeService()
    const [item, setItem] = useState({...itemData})
    const [deleteModal, setDeleteModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [itemStatus, setItemStatus] = useState(false)
    const [modal, setModal] = useState(false)
    const [addEditRateModal, setAddEditRateModal] = useState(false)
    const [add, setAdd] = useState(true)
    const [loading, setLoading] = useState(false)
    const [deletedRatesList, setDeletedRatesList] = useState([])
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const filterData = useSelector(state => state.adminFilter)
    const dispatch = useDispatch()
    const isExist = (data) => AuthData.permissions[data]
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const toggleModal = () => setModal(!modal)
    const id = item.id || localStorage.getItem('compound_id')

    const rate = (Number.isInteger(item?.rate/item?.count))?((item?.rate/item?.count)):((item?.rate/item?.count).toFixed(2))

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }

    const changeStatus = () => {
        setLoading(true)
        service.toggleStatus('Compound', item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                setShouldGetData(true)
                toast.success('Status changed successfully')
                setLoading(false)
            }
        })
    }

    useEffect(()=>{
        if(item?.has_interactives){
            interActiveModeService.getInteractiveMode(item.id).then(res=> setItem({...item, interactive: {...res.data[0]}}))
        }
    },[])

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>
                    <Link to={`${salesDeveloperPrefix}/cards/${id}`} onClick={()=> {
                        localStorage.setItem('compound_id', item.id)
                        dispatch(appendFilters({compound_id: item.id, compound: {
                        label: item.name ?.en,
                        value: item?.id
                    }}))}}>
                    {item.name ?.en}
                    </Link>
                </td>
                <td className='font-size-13'>
                    <Badge className="bgBadge font-size-14 mt-0 m-1"  
                            style={{ background: "#50a5f1",marginTop:"0px !important" }}>
                                {item.area?.name?.en}
                    </Badge>
                </td>
                <td className='font-size-13'> {item?.left_units}</td>
                <td className='font-size-13'>
                    {item?.has_interactives ? 
                    <button 
                        className={`text-success ${isExist('add_compound') ?'interactive-button' :''}` }
                        style={{fontWeight: 700, border:'none', background:'none', cursor: isExist('add_compound') ? 'pointer' : 'text' }}
                        onClick={()=> {
                            if(!isExist('add_compound')){
                                return
                            }
                            setModal(true)
                            dispatch(appendData({
                                compound: {label: item?.name?.en, value: item?.id, name: item.name}, 
                                developer_id: item?.developer?.id}))
                            dispatch(appendFilters({has_interactive: item?.has_interactives, compound_id: item.id, developer_id: item?.developer?.id,}))}
                        }
                    >On</button> : 
                    <button 
                        className={`error ${isExist('add_compound') ?'interactive-button' :''}` }
                        style={{fontWeight: 700, border:'none', background:'none', cursor: isExist('add_compound') ? 'pointer' : 'text'}}
                        onClick={()=> {
                            if(!isExist('add_compound')){
                                return
                            }
                            setModal(true)
                            dispatch(appendData({
                                compound:{label: item?.name.en,value: item.id}, 
                                developer_id: item?.developer?.id}))
                            dispatch(appendFilters({has_interactive: item?.has_interactives, compound_id: item.id, developer_id: item?.developer?.id,}))}
                        }
                    >Off</button>}
                </td>
                <td className='font-size-13'>
                    {!isNaN(rate) ? `${rate} %` : '-'}
                </td>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={!isExist('edit_compound')}
                            />
                        </div>
                    </form>
                </td>
                
                <td className="removebtnhover">
                    {(isExist('add_compound') || isExist('edit_compound')) &&<Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            {isExist('edit_compound') && <DropdownItem onClick={updateHandler}>Edit Information</DropdownItem>}
                            
                            {isExist('edit_compound') && <DropdownItem onClick={()=>{
                                dispatch(appendFilters({
                                    developer_id: item?.developer?.id,
                                    compound_id: item?.id
                                }))
                                isNaN(rate) ? setAdd(true) : setAdd(false)
                                setAddEditRateModal(true)
                            }}>
                                {isNaN(rate) ? 'Add Compound Rates' : 'Edit Compound Rates'}
                            </DropdownItem>}
                            {isExist('add_compound') &&<DropdownItem 
                                    onClick={()=>{
                                        dispatch(appendFilters({
                                            path: 'fromCompound',
                                            compound_id: item.id
                                        }))
                                        history.push(`${salesDeveloperPrefix}/create-building/${item.id}`)
                                    }} >Add Building</DropdownItem>}
                            {isExist('add_compound') &&<DropdownItem  
                                    onClick={()=>{
                                        dispatch(appendFilters({
                                            path: 'fromCompound',
                                            addProperty: 'property',
                                            compound_id: item.id
                                        }))
                                        history.push(`${salesDeveloperPrefix}/create-property`)
                                    }}
                                >Add Property</DropdownItem>}
                                
                                {isExist('delete_compound') && <DropdownItem className="text-danger" onClick={() => setDeleteModal(!deleteModal)}>Remove Compound</DropdownItem>}
                             
                        </DropdownMenu>
                    </Dropdown>}
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={item.name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            {modal && <ModalForm
                toggle={toggleModal}
                modal={modal}
                from='compound'
                item={item}
                history={history}
                editMode={item.interactive}
                setShouldGetData={setShouldGetData}
                setUpdateOptions={()=>{}}
            />}
            {addEditRateModal ? <EditRateModal
                        add={add}
                        modal={addEditRateModal}
                        toggle={()=> setAddEditRateModal(false)}
                        getList={setShouldGetData}
                        editRate={item}
                        setShowSuccessModal={setShowSuccessModal}
                        setDeletedRatesList={setDeletedRatesList}
                        // deletedRatesList={deletedRatesList}
                    /> : null
                    }
            {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Add New Rate"}
                        subtitle={"Admin can add rate to any developer"}
                        message={"The Rate successfully Added"}
                        onClick={() => {
                            setShouldGetData(true)
                            setShowSuccessModal(false)
                        }} />}
        </>

    )
}

export default CardItem